module.exports = __webpack_public_path__ + "img/IconoImagenEurocaja.a41f2bb0.png";